import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
export const StyledFieldset = styled.fieldset `
  margin: 0;
  padding: 0;

  border: 0;

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=FormGroup.styles.js.map